// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__+qYpE","footerdiv":"Footer_footerdiv__KnS+h","telephone":"Footer_telephone__aA0Tw","telephoneicon":"Footer_telephoneicon__cFLgz"};